import React, { Component } from 'react';
import styled from 'styled-components';
import email from 'services/email';
import PropTypes from 'prop-types';

import TitleWithShape from 'components/TitleWithShape';
import HelpText from 'components/HelpText';

import QLTickIcon from 'assets/images/QL-Tick.svg';
import LogoIcon from 'assets/images/logo/Logo-QL-Blue.svg';

const Wrapper = styled.div`
  color: #35447d;
  padding-left: 5.4rem;
  padding-right: 5.4rem;
  padding-top: 6.8rem;
  .page-title {
    display: flex;
    padding-left: 9rem;
    align-items: center;
    img {
      margin-top: -3rem;
      margin-right: 2rem;
      height: 12rem;
      width: 12rem;
    }
  }
  .sub-title {
    padding: 0 10rem;
    margin-top: 1.45rem;
    font-size: 1.45rem;
  }
  .form-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 9rem;
    .left-pane {
      background: #F8F7F3;
      width: 66rem;
      position: relative;
      padding: 10rem 10rem;
      .logo {
        display: flex;
        justify-content: space-between;
        img {
          height: 3rem;
        }
      }
      P {
        padding: 0;
        margin: 0;
      }
      .text {
        font-size: 2rem;
      }
      .strong-text {
        font-size: 2.6rem;
        font-weight: 600;
      }
      .reference {
        font-size: 2.6rem;
        margin-top: 4rem;
      }
      .date {
        margin-top: 2.5rem;
      }
      .bill {
        margin-top: 2.5rem;
      }
      .description {
        display: flex;
        justify-content: space-between;
        padding-bottom: 2px;
        border-bottom: 2px solid #8aebf1;
      }
      .h2 {
        margin-top: 2.5rem;
      }
      .label {
        flex: 1;
      }
      .quantity {
        width: 50px;
        text-align: center;
      }
      .price {
        width: 80px;
        text-align: right;
      }
      .second {
        display: flex;
        justify-content: space-between;
        padding: 2.5rem 0;
        border-bottom: 2px solid #8aebf1;
        margin-bottom: 5px;
      }
      .result {
        display: flex;
        justify-content: flex-end;
        margin-left: auto;
        padding: 2px;
        .label {
          text-align: right;
        }
        .value {
          width: 15rem;
          text-align: right;
        }
      }
      .result.sub {
        padding: 0;
      }
      .total {
        font-size: 2rem;
      }
    }
    .right-pane {
      margin-top: 6rem;
      margin-left: 12rem;
      width: 36rem;
    }
  }

  @media only screen and (max-width: 1100px) {
    padding-left: 0;
    padding-right: 0;
    margin-top: auto;
    .form-wrapper {
      flex-direction: column-reverse;
      margin-left: auto;
      margin-right: auto;
      margin-top: 0;
      align-items: center;
      .left-pane {
        margin-top: 5rem;
      }
      .right-pane {
        justify-content: center;
        margin-bottom: 3rem;
        margin-left: 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .page-title {
      padding-left: 0;
    }
  }
`;

class Step10 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    // Send email
    if (!this.props.formData.step10.emailSent) {
      email.application(this.props.formData);
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/email`, {
        method: 'POST',
        body: JSON.stringify(email),
      })
        .then((res) => {
          if (res.ok) {
            // Send application confirmation to user
            email.applicationConfirmation(this.props.formData);
            fetch(`${process.env.REACT_APP_API_ENDPOINT}/email`, {
              method: 'POST',
              body: JSON.stringify(email),
            }).then(() => this.props.finaliseForm());
          } else {
            alert('Something went wrong. Please contact QuickLegal.');
          }
        });
    }
    // Register GA conversion
    fetch('https://www.googleadservices.com/pagead/conversion/812813115/?label=rghaCLTi3H4Qu5bKgwM');
  }

  render() {
    return (
      <Wrapper>
        <div className="page-title">
          <img alt="ql-tick" src={QLTickIcon} />
          <TitleWithShape
            title="You're all done! You should receive an email shortly with all your information."
          />
        </div>
        <p className="sub-title">See below for a confirmation of your payment. We'll get in touch with you shortly.</p>
        <div className="form-wrapper">
          <div className="left-pane">
            <div className="logo">
              <img alt="logo" src={LogoIcon} />
              <p className="text">Confirmation</p>
            </div>
            <p className="reference strong-text">Reference Number</p>
            <p className="text">{this.props.formData.step9.receiptNumber}</p>
            <p className="date strong-text">Date</p>
            <p className="text">{new Date().toDateString()}</p>
            <p className="bill strong-text">Billing to</p>
            <p className="text">{this.props.formData.step1.name},</p>
            <p className="text">{this.props.formData.step1.email}</p>
            <p className="text">{this.props.formData.step1.phone}</p>
            <h2 className="h2 strong-text">ORDER SUMMARY</h2>
            <div className="description">
              <p className="label text">Description</p>
              <p className="quantity text">Qty</p>
              <p className="price text">Price</p>
            </div>
            <div className="description second">
              <p className="label text">Quick Legal Package</p>
              <p className="quantity text">1</p>
              <p className="price text">$880.00</p>
            </div>
            <div className="result">
              <p className="label text">Subtotal</p>
              <p className="value text">$880.00</p>
            </div>
            <div className="result">
              <p className="label text">GST</p>
              <p className="value text">$80.00</p>
            </div>
            <div className="result">
              <p className="label strong-text">Total</p>
              <p className="value strong-text">$880.00</p>
            </div>
            <div className="result sub">
              <p className="label" />
              <p className="value text">incl. GST</p>
            </div>
          </div>
          <div className="right-pane">
            <HelpText>Keep this information for later as a reference</HelpText>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Step10.propTypes = {
  finaliseForm: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Step10;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step10.js